import { SVGProps } from 'react';

const SvgClipboardMedical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24v-24c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-56 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
      className="clipboard-medical_svg__fa-primary"
    />
    <path
      d="M113.2 66.3c.1-.8.3-1.6.4-2.3H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-49.6c.2.8.3 1.6.4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24v-24c0-21.3 13.9-39.4 33.2-45.7zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48z"
      style={{
        opacity: 0.4,
      }}
    />
  </svg>
);
export default SvgClipboardMedical;
